import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { setFinishedStep, updatePropInStepCheckPhotos } from '../enCursoSlice'
import { useDispatch, useSelector } from 'react-redux'
import { TrootState } from '../../../app/rootReducer'

import Modal from '../../../components/modal/modal'
import ModalUploadFoto from '../modalUploadFoto'

import uploadFoto  from '../../../assets/icons/ui/photo.png'
import uploadedFoto  from '../../../assets/icons/ui/photo_uploaded.png'

export type TpropFotos = {
  value: boolean,
  prop: string,
  title: string,
  img: Blob | undefined,
  imgUrl: string | undefined,
}

const initialForm = [
  { value: false, prop: 'foto_volante', title: 'Cargar foto del volante', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_tablero_01', title: 'Cargar foto del tablero 1', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_tablero_02', title: 'Cargar foto del tablero 2', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_asientos_delanteros', title: 'Cargar fotos de los asientos delanteros', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_asientos_traseros', title: 'Cargar fotos de los asientos traseros', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_caja_cambio', title: 'Cargar fotos de la caja de cambio', img: undefined, imgUrl: undefined },
  { value: false, prop: 'foto_puerta_conductor_adentro', title: 'Cargar fotos de los puerta del conductor desde adentr', img: undefined, imgUrl: undefined }
]

export default function Fotos02_interior() {
  const dispatch = useDispatch()
  const [ showModal, setShowModal] = useState<boolean>(false);
  const [ uploads, setUploads ] = useState<TpropFotos[]>(initialForm)
  const [ currentUpload, setCurrentUpload ] = useState<TpropFotos | undefined>(undefined)

  const displayModal = () => setShowModal(true)
  const hiddeModal = () => setShowModal(false)

  const currentStep = useSelector((state: TrootState) => {
    return state.enCurso.checkSteps[3].steps[3]
  })

  useEffect(() => {
    setUploads((state) => {
      return state.map((prop, idx) => {
        const entry = currentStep.props.find((propEntry) => propEntry.prop === prop.prop)

        if (entry)
        return { ...prop, value: entry.value }
        else
        return { ...prop }
      })
    })
  }, [])

  useEffect(() => {
    const evalueProps: boolean[] = uploads.map(item => {
      return item.value
    })

    const thereIsUnfilled = evalueProps.some((item) => item === false)

    if (!thereIsUnfilled) {
      dispatch(setFinishedStep())
    }

  }, [uploads])

  function setBlob(prop: string, blobImg: Blob, urlImg: string) {
    const index = uploads.findIndex((item) => item.prop === prop)

    setUploads(uploads.map((item, idx) => {
      if (idx === index) return { ...item, value: true, img: blobImg, imgUrl: urlImg }
      return item
    }))

    dispatch(updatePropInStepCheckPhotos({ stepIdx: 3, propIdx: index, payload: { value: true } }))

    hiddeModal()
  }

  function clickUpload(prop: string) {
    setCurrentUpload(uploads.find((item) => item.prop === prop))
    displayModal()
  }

  return(
    <>
      <FotosContainer finished={currentStep?.finished ? true : false}>
        { uploads.map((upload, idx) => (
          <Upload
            key={`upload${idx}`}
            onClick={() => clickUpload(upload.prop)}
          >
            <UploadIcon src={ upload.imgUrl ? upload.imgUrl : upload.value ? uploadedFoto : uploadFoto } />
            { upload.value && 
              <SubidoText> Guardado </SubidoText>
            }
            <Text> { upload.title } </Text>
          </Upload>
        ))}

      </FotosContainer>

      { showModal && 
        <Modal
          closeModal={hiddeModal}
        >
          <ModalUploadFoto
            prop={currentUpload}
            setFoto={setBlob}
            hiddeModal={hiddeModal}
          />
        </Modal>
      }
    </>
  )
}

interface TfotosContainer { finished: boolean }
const FotosContainer = styled.div<TfotosContainer>`
  display: flex;
  justify-content: space-evenly;
  flex-flow: row wrap;
  ${(args) => args.finished && `
    opacity: 0.5;
  `}
`
const Upload = styled.div`
  position: relative;
  margin-top: 10px;
  width: 40%;
`
const UploadIcon = styled.img`
  width: 150px;
`
const Text = styled.div`
  font-family: Barlow;
  font-size: 12px;
`
const SubidoText = styled.div`
  font-family: Barlow;
  font-size: 20px;
  font-weight: 800;
  position: absolute;
  top: 10px;
  left: 50px;
  color: #9b4573;
`